import React, { Component } from "react";
import "./home.scss";
import SearchBar from "./components/searchbar";
import Button from "./components/MaterialButton";
import { BlockReserveLoading } from "react-loadingg";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import MaterialDialoge from "./components/dialoge";
// import Navbar from "../../components/navbar/Navbar";
import Card2 from "./components/card2";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      city: "",
      loading: false,
      carousal: "1",
      cards: [],
      searchErrorMsg: "",
      disableEmbedButton: true,
      dialogeOpen: false,
    };
  }

  handleSearch = (e) => {
    this.setState({ city: e });
  };

  handleRadioChange = (e) => {
    this.setState({ carousal: e.target.value });
  };

  callAPI = () => {
    if (this.state.city === "") return;
    this.setState({
      loading: true,
      disableEmbedButton: true,
      cards: [],
      searchErrorMsg: "",
    });
    let url = `https://hearrealtors.herokuapp.com/carousel?city=${this.state.city}&carousal=${this.state.carousal}`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.setState({
            loading: false,
            searchErrorMsg: "Invalid City",
            disableEmbedButton: true,
          });
        } else
          this.setState({
            loading: false,
            cards: data,
            searchErrorMsg: "",
            disableEmbedButton: false,
          });
        console.log(data);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          searchErrorMsg: "No results Founds :( ",
          disableEmbedButton: true,
        });
        console.log(err);
      });
  };

  handleEmbed = (x) => {
    x === "o"
      ? this.setState({ dialogeOpen: true })
      : this.setState({ dialogeOpen: false });
  };

  renderCards = () => {
    return this.state.cards.length > 0
      ? this.state.cards.map((card) => (
          <div className="Home-Card-Container">
            <Card2
              address={card.address}
              baths={card.baths}
              beds={card.beds}
              family={card.family}
              price={card.price}
              imageUrl={card.imageUrl}
              sqft={card.sqft}
              link={card.link}
              // courtesy={}
            />
          </div>
        ))
      : null;
  };
  render() {
    return (
      <>
        {/* <Navbar /> */}
        <div>
          <div className="Home-Search-Wrapper">
            <div className="Home-Search-container">
              <div className="Home-Search-Input">
                <SearchBar handleChange={(t) => this.handleSearch(t)} />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div className="Home-Search-Button">
                  <Button
                    text="SEARCH"
                    handleClick={this.callAPI}
                    disabled={this.state.loading}
                  />
                </div>
                <div className="Home-Embed-Container">
                  <Button
                    text="Embed"
                    handleClick={() => this.handleEmbed("o")}
                    disabled={this.state.disableEmbedButton}
                  />
                </div>
              </div>
            </div>
            <div className="Home-Radio-container"> 
              <div className="Home-Radio-Label">Carousel</div>
              <FormControl component="fieldset">
                <RadioGroup
                  name="Carousel"
                  value={this.state.carousal}
                  onChange={this.handleRadioChange}
                  row
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio color="primary" />}
                    label="8 listings"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio color="primary" />}
                    label="16 listings"
                  />
                </RadioGroup>
              </FormControl>
              {/* <div className="Home-Embed-Container">
                <Button
                  text="Embed"
                  handleClick={() => this.handleEmbed("o")}
                  disabled={this.state.disableEmbedButton}
                />
              </div> */}
            </div>
          </div>
          <MaterialDialoge
            Open={this.state.dialogeOpen}
            Close={() => this.handleEmbed("c")}
            city={this.state.city}
            noOfCarousel={this.state.carousal}
          />
          <div className="Home-Cards-Wrapper">
            {this.state.cards.length > 0
              ? this.renderCards()
              : this.state.searchErrorMsg
              ? this.state.searchErrorMsg
              : null}
          </div>
          {this.state.loading ? (
            <BlockReserveLoading color="#123abc" size="large" />
          ) : null}
        </div>
      </>
    );
  }
}

export default React.memo(Home);
